import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import ProjectCard from "./ProjectCards";

import GSM from "../../Assets/Projects/GSM.png";
import Portfolio from "../../Assets/Projects/Portfolio.png";
import Ecart from "../../Assets/Projects/ecart.png";
import Resultify from "../../Assets/Projects/Resultify.png";
import derma from "../../Assets/Projects/derm.png";
import Hostel from "../../Assets/Projects/host.png";
import job from "../../Assets/Projects/job1.png";



import "./project.css";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="Fluorescent-Blue">Works </strong>
        </h1>
        <p>Here are a few projects I've worked on recently.</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Hostel}
              title="Hostel-Hub: Digitalization of MIT Hostel"
              description="Developed a comprehensive hostel app to streamline room allocation, fee tracking, and student-staff
 interactions, enhancing the overall student experience.
 Empowered admins with tools for efficient room inspections, request handling, issue resolution, and staff
 coordination.
 Tech Stack: Flutter, Google sheet API, Firebase, SQLite"
              ghLink=""
              demoLink=""
            />
          </Col>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={derma}
              title="DermaCare "
              description=" Developed an AI-powered mobile application for preliminary skin disease diagnosis, featuring image analysis
 and secure data management.
 Implemented machine learning algorithms for accurate image recognition, providing personalized diagnostic
 feedback.
 Tech Stack: Flutter,Machine Learning,Image Processing,Firebase"
              ghLink="https://github.com/sakshiselmokar/Skin-Disease-Diagnosis"
              demoLink="https://drive.google.com/file/d/11nRYN_EOyRFKLGxEpcCQleA-eBgkdKCa/view?usp=sharing"
            />
          </Col>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={job}
              title="JobAR-AR-Powered Job Finder"
              description=" Developed a mobile application combining AI and Augmented Reality to provide real-time, personalized job
 notifications.
 Integrated GPS and machine learning algorithms to enhance job search functionality.
 Tech Stack: Flask API, Python, React Native, ARCore, TensorFlow "
              ghLink=""
              demoLink="https://drive.google.com/file/d/1yfP853lvSISHP5JpwOMA2bWAuTWTuC31/view?usp=drivesdk"
            />
          </Col>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Resultify}
              title="Result Management"
              description="Resultify is a web-based application simplifying student result management, featuring student and admin portals for result access and upload, with responsive design and easy integration. "
              ghLink="https://github.com/sakshiselmokar/Resultify"
              demoLink="https://sakshiselmokar.github.io/Resultify/"
            />
          </Col>
                <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              title="Portfolio Website"
              description=" Designed and built an engaging personal portfolio website offering a consistent and responsive user
 experience across all devices.
 Showcased professional achievements, projects, and skills in a visually appealing format.
 Tech Stack: React.js, React Bootstrap, Netlify ,Nodejs"
              ghLink="https://github.com/sakshiselmokar/Portfolio"
              demoLink="https://sakshiselmokar.netlify.app/"
            />
          </Col>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={GSM}
              title="GSM Digital Repository"
              description="A web app allowing users to securely upload and manage documents in a digital repository."
              ghLink="https://github.com/sakshiselmokar/GSM-Digital-Repository"
              demoLink="https://sakshiselmokar.github.io/GSM-Digital-Repository/"
            />
          </Col>

        
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Ecart}
              title="E Cart"
              description="a responsive Ecommerce Website with HTML,CSS,Bootstrap,JavaScript."
              ghLink="https://github.com/sakshiselmokar/E-com"
              demoLink="https://sakshiselmokar.github.io/E-com/"
            />
          </Col>
          

        </Row>
      </Container>
      <ScrollToTop />
    </Container>
  );
}

export default Projects;
